var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.item.config && !!_vm.item.config['tag-oid'])?_c('InfoBranch',{style:({
    marginTop: '2px',
  }),attrs:{"content":_vm.item.meta.name}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }